import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  buttonTextFocused: {
    color: Theme.colorFocusText,
  },
  buttonText: {
    color: Theme.white,
    fontSize: Theme.px(36),
  },
  buttonTextDisabled: {
    color: Theme.malibuBlue,
  },
  buttonFocused: {
    backgroundColor: Theme.white,
  },
  buttonContainer: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  content: {
    borderRadius: Theme.tileBorderRadius,
    flexDirection: 'row',
    height: '100%',
    width: '100%',
  },
  buttonContent: {
    flexDirection: 'row',
  },
});
